/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type Inconveniences = "External" | "MissedLunch" | "NoMeetingRelief" | "OnNoMeetingDay" | "Other" | "OutsideMeetingHours" | "OutsideWorkingHours" | "Uncrawled" | "%future added value";
export type SchedulingAttendanceSummaryTag = "Best" | "Conflict" | "Current" | "Good" | "InFocusTime" | "Inconvenient" | "MostFocus" | "OverLunch" | "Soonest" | "%future added value";
export type SchedulingResponseQualifier = "NoConvenientTimesWithRooms" | "%future added value";
export type EventSchedulerSuggestedTimes_schedulingResponse = {
    readonly uncrawledCalendars: ReadonlyArray<string | null>;
    readonly qualifiers: ReadonlyArray<SchedulingResponseQualifier | null> | null;
    readonly queryRecommendation: {
        readonly availableDate: string | null;
        readonly minutesDuration: string | null;
    } | null;
    readonly slots: ReadonlyArray<{
        readonly summary: {
            readonly availableRooms: ReadonlyArray<string>;
            readonly tags: ReadonlyArray<SchedulingAttendanceSummaryTag | null> | null;
            readonly freeAttendees: ReadonlyArray<string>;
            readonly inconvenientForAttendees: ReadonlyArray<string>;
            readonly focusTimeMinutesCost: number;
            readonly conflictingAttendees: ReadonlyArray<string>;
        };
        readonly attendanceImpacts: ReadonlyArray<{
            readonly calendarId: string;
            readonly inconveniences: ReadonlyArray<Inconveniences>;
            readonly hasConflict: boolean;
            readonly focusTimeMinutesCost: number;
            readonly conflictingMeetings: ReadonlyArray<string>;
        }>;
        readonly roomImpacts: ReadonlyArray<{
            readonly available: boolean;
            readonly tooSmall: boolean;
            readonly tooLarge: boolean;
            readonly roomId: string;
        }>;
        readonly timeRange: {
            readonly id: string;
            readonly startTime: {
                readonly type: EventTimeType;
                readonly dateOrDateTime: string;
                readonly timeZone: string | null;
                readonly offsetMinutes: number | null;
                readonly millis: number;
            } | null;
            readonly endTime: {
                readonly type: EventTimeType;
                readonly dateOrDateTime: string;
                readonly timeZone: string | null;
                readonly offsetMinutes: number | null;
                readonly millis: number;
            } | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"EventSchedulerSuggestedTime_schedulingSlot">;
    }>;
    readonly " $refType": "EventSchedulerSuggestedTimes_schedulingResponse";
};
export type EventSchedulerSuggestedTimes_schedulingResponse$data = EventSchedulerSuggestedTimes_schedulingResponse;
export type EventSchedulerSuggestedTimes_schedulingResponse$key = {
    readonly " $data"?: EventSchedulerSuggestedTimes_schedulingResponse$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSchedulerSuggestedTimes_schedulingResponse">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusTimeMinutesCost",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventSchedulerSuggestedTimes_schedulingResponse",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uncrawledCalendars",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "qualifiers",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "QueryRecommendation",
                "kind": "LinkedField",
                "name": "queryRecommendation",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableDate",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesDuration",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulingSlot",
                "kind": "LinkedField",
                "name": "slots",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingAttendanceSummary",
                        "kind": "LinkedField",
                        "name": "summary",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "availableRooms",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tags",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "freeAttendees",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconvenientForAttendees",
                                "storageKey": null
                            },
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingAttendees",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingAttendanceImpact",
                        "kind": "LinkedField",
                        "name": "attendanceImpacts",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconveniences",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasConflict",
                                "storageKey": null
                            },
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingMeetings",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingRoomImpact",
                        "kind": "LinkedField",
                        "name": "roomImpacts",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "available",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tooSmall",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tooLarge",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roomId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRange",
                        "kind": "LinkedField",
                        "name": "timeRange",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "id",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "startTime",
                                "plural": false,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "endTime",
                                "plural": false,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventSchedulerSuggestedTime_schedulingSlot"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "SchedulingResponse",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '0edb43e2f09f9950245f32ac6b3e3d6c';
export default node;
